export default (field: string[]) => {
    let response: string = '';
    field.map((field_error, index_field_error) => response += `${index_field_error > 0 ? ', ' : ''}${field_error}`);
    return response;
};